import { Dropdown } from "antd";
import { ChevronDown } from "lucide-react";
import { useState } from "react";
import { useTranslation } from "react-i18next";

interface Props {
    value: string;
    onChange: (key: string) => void;
}

const TimeFilter = ({ value, onChange }: Props) => {
    const { t } = useTranslation();
    const [open, setOpen] = useState(false);

    const options = [
        { key: "today", label: t("lead.time_today") },
        { key: "yesterday", label: t("lead.time_yesterday") },
        { key: "this_week", label: t("lead.time_this_week") },
        { key: "last_week", label: t("lead.time_last_week") },
        { key: "this_month", label: t("lead.time_this_month") },
        { key: "last_month", label: t("lead.time_last_month") },
    ];

    const content = (
        <div className="p-2 w-[200px] max-h-[260px] overflow-y-auto bg-white dark:bg-[#1f1f1f] rounded-lg shadow-lg">
            {value && (
                <div
                    onClick={() => { onChange(""); setOpen(false); }}
                    className="px-3 py-2 rounded cursor-pointer transition text-gray-400 text-[13px] hover:bg-gray-100 dark:hover:bg-[#2a2a2a] mb-1"
                >
                    {t("lead.filter_time_created")}
                </div>
            )}
            {options.map((item) => (
                <div
                    key={item.key}
                    onClick={() => {
                        onChange(item.key);
                        setOpen(false);
                    }}
                    className={`px-3 py-2 rounded cursor-pointer transition text-000000e0 text-[14px]
                        ${value === item.key
                            ? "bg-blue-100 text-[#3e91ab] dark:bg-[#2a2a2a]"
                            : "hover:bg-gray-100 dark:hover:bg-[#2a2a2a]"
                        }`}
                >
                    {item.label}
                </div>
            ))}
        </div>
    );

    return (
        <Dropdown
            dropdownRender={() => content}
            trigger={["click"]}
            open={open}
            onOpenChange={setOpen}
            getPopupContainer={() => document.body}
        >
            <div
                className={`flex items-center gap-1 px-3 py-1 rounded cursor-pointer transition text-000000e0 text-[14px]
                    ${open || value
                        ? "bg-blue-100 !text-[#3e91ab] dark:bg-[#2a2a2a]"
                        : "bg-gray-100 dark:bg-[#1f1f1f]"
                    }`}
            >
                {value ? options.find(o => o.key === value)?.label : t("lead.filter_time_created")}

                <ChevronDown
                    size={16}
                    className={`transition-transform duration-200 ${open ? "rotate-90" : ""}`}
                />
            </div>
        </Dropdown>
    );
};

export default TimeFilter;